export default __webpack_public_path__ + "static/media/rectangle-grey.37028733.svg";